import { Injectable } from '@angular/core';
import { COUNTRIES, Country } from '@/app/data/countries';

@Injectable({ providedIn: 'root' })
export class CountryService {
    private readonly byCode = new Map<string, Country>(
        COUNTRIES.map(c => [c.code, c])
    );

    getAll(): readonly Country[] {
        return COUNTRIES;
    }

    getName(code: string | null | undefined): string {
        if (!code) return '';
        return this.byCode.get(code.toUpperCase())?.name ?? code;
    }

    isValid(code: string | null | undefined): boolean {
        if (!code) return false;
        return this.byCode.has(code.toUpperCase());
    }
}
